/*
  nazzi-hp.js
  Interazioni della homepage v2, vanilla e leggere:
  - comparsa morbida dei blocchi allo scroll (solo transform e opacity);
  - frecce degli slider a scroll-snap;
  - aggiunta rapida al carrello dalle card prodotto;
  - pausa fuori schermo delle recensioni a scorrimento.
  Tutto e progressive enhancement: senza JS la pagina resta completa.
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Comparsa allo scroll. La classe sul root viene messa solo se l'observer
     esiste, cosi senza JS o su browser vecchi nulla resta nascosto. */
  function reveal() {
    var items = document.querySelectorAll('[data-nazzi-reveal]');
    if (!items.length || reduceMotion || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('nazzi-hp-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Slider: i bottoni con data-nazzi-slide spostano la traccia di una card */
  function sliders() {
    document.querySelectorAll('[data-nazzi-slider]').forEach(function (root) {
      var track = root.querySelector('[data-nazzi-track]');
      if (!track) return;
      var buttons = root.querySelectorAll('[data-nazzi-slide]');
      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        buttons.forEach(function (b) {
          var dir = Number(b.getAttribute('data-nazzi-slide'));
          b.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max;
        });
      }
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: step() * Number(b.getAttribute('data-nazzi-slide')), behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });
      // Stato iniziale senza leggere il layout (la sezione puo essere
      // rimandata con content-visibility): all'inizio si e sempre a sinistra.
      buttons.forEach(function (b) {
        b.disabled = Number(b.getAttribute('data-nazzi-slide')) < 0;
      });
    });
  }

  /* Aggiunta rapida: stesso schema della scheda prodotto. La fetch verso
     /cart/add.js viene intercettata da Moon Bundle, che apre il suo mini
     cart; openMoonBundleCartDrawer resta come fallback esplicito. In caso
     di errore il form parte in modo nativo e l'utente arriva al carrello. */
  function quickAdd() {
    document.querySelectorAll('form[data-nazzi-quick-add]').forEach(function (form) {
      var btn = form.querySelector('button');
      var busy = false;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (busy) return;
        busy = true;
        if (btn) btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart-add ' + r.status);
            return r.json();
          })
          .then(function () {
            if (typeof window.openMoonBundleCartDrawer === 'function') window.openMoonBundleCartDrawer();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (btn) {
              btn.classList.add('is-done');
              setTimeout(function () { btn.classList.remove('is-done'); }, 1800);
            }
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            busy = false;
            if (btn) btn.classList.remove('is-loading');
          });
      });
    });
  }

  /* Recensioni a scorrimento. Nell'HTML ogni recensione c'e una volta sola:
     qui si clona il gruppo per il loop (copia nascosta a lettori di schermo
     e tastiera) e si attiva l'animazione CSS, che va in pausa quando la
     sezione e fuori schermo. Con movimento ridotto non si fa nulla e le
     righe restano scorribili a mano. */
  function marquees() {
    var boxes = document.querySelectorAll('[data-nazzi-marquee]');
    if (!boxes.length || reduceMotion) return;
    boxes.forEach(function (box) {
      box.querySelectorAll('.nazzi-hp-marquee__row').forEach(function (row) {
        var group = row.querySelector('.nazzi-hp-marquee__group');
        if (!group || row.children.length > 1) return;
        var copy = group.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
        row.appendChild(copy);
      });
      box.classList.add('is-looping');
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        en.target.classList.toggle('is-offscreen', !en.isIntersecting);
      });
    }, { rootMargin: '100px 0px' });
    boxes.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    reveal();
    sliders();
    quickAdd();
    marquees();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
